<template>
  <div class="max-w-7xl mx-auto px-6 lg:px-8">
    <BreadCrumbs v-bind:bcrumbs="bcrumbs" />
    <PageTitle v-bind:title="title" v-bind:admin="true" />

    <ErrorMessage v-if="errors.load" :error="errors.load" class="mt-2" />

    <Loader v-if="loading" />
    <div v-else-if="data.id" class="my-8 max-w-4xl mx-auto">
      <div class="space-y-8 divide-y divide-gray-200">
        <div>
          <div class="text-center">
            <p class="text-sm font-medium text-gray-700">Обложка курса</p>
            <img
              v-if="data.image"
              :src="data.image"
              alt=""
              height="300"
              class="h-40 mt-2 rounded-sm mx-auto"
            />
            <p v-else class="text-sm font-medium text-gray-400">
              Необходимо загрузить изображение:
            </p>
            <p class="text-sm font-bold text-gray-700">
              картинка должна быть широкой!
            </p>
            <form @submit.prevent="submit" class="mt-2">
              <label
                for="file-upload"
                class="relative cursor-pointer bg-white rounded-md font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500"
              >
                <span>Выберите файл для загрузки</span>
                <input
                  @change="onAttachmentChange"
                  id="file-upload"
                  name="file-upload"
                  type="file"
                  class="sr-only"
                />
              </label>

              <button
                type="submit"
                class="ml-5 bg-white py-2 px-3 border border-gray-300 rounded-md shadow-sm text-sm leading-4 font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                Сохранить обложку
              </button>

              <ErrorMessage
                v-if="errors.uploadfile"
                :error="errors.uploadfile"
              />
            </form>
          </div>
          <form class="space-y-4">
            <input type="hidden" name="id" v-model="data.id" />

            <div>
              Состояние Курса:
              <span
                :class="[
                  'font-bold',
                  data.coursestate.id == 5 ? 'text-green-500' : '',
                  data.coursestate.id == 1 ? 'text-gray-500' : '',
                ]"
                >{{ data.coursestate.name }}</span
              >
            </div>

            <div>
              <label for="name" class="block text-sm font-medium text-gray-700">
                Название курса
              </label>
              <div class="mt-1">
                <input
                  v-model="data.name"
                  type="text"
                  name="name"
                  id="name"
                  autocomplete="name"
                  class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                />
                <p
                  v-if="errors.validationEdit && errors.validationEdit.name"
                  class="mt-2 text-sm text-red-600"
                >
                  {{ errors.validationEdit.name[0] }}
                </p>
              </div>
            </div>

            <div>
              <label
                for="department"
                class="block text-sm font-medium text-gray-700"
              >
                Кафедра
              </label>
              <div class="mt-1">
                <select
                  v-model="data.department_id"
                  :required="true"
                  id="department"
                  name="department"
                  autocomplete="department"
                  class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                >
                  <option
                    v-for="department in departments"
                    v-bind:value="department.id"
                    v-bind:key="department.id"
                    :selected="department.id == data.department_id"
                  >
                    {{ department.name }}
                  </option>
                </select>
              </div>
            </div>

            <div>
              <label
                for="category"
                class="block text-sm font-medium text-gray-700"
                >Категория</label
              >
              <div class="mt-1">
                <select
                  v-model="data.category_id"
                  :required="true"
                  id="category"
                  autocomplete="category"
                  class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                >
                  <option
                    v-for="category in categories"
                    v-bind:value="category.id"
                    v-bind:key="category.id"
                    :selected="category.id == data.category_id"
                  >
                    {{ category.name }}
                  </option>
                </select>
              </div>
            </div>

            <div>
              <label
                for="duration"
                class="block text-sm font-medium text-gray-700"
                >Примерная длительность (время на прохождение курса)</label
              >
              <div class="mt-1">
                <input
                  v-model="data.duration"
                  type="text"
                  name="duration"
                  id="duration"
                  autocomplete="duration"
                  class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                />
              </div>
            </div>

            <div>
              <label
                for="description"
                class="block text-sm font-medium text-gray-700"
              >
                Описание курса
              </label>
              <div class="mt-1">
                <textarea
                  v-model="data.description"
                  id="description"
                  name="description"
                  rows="3"
                  class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                ></textarea>
              </div>
            </div>

            <div>
              <div class="flex justify-end">
                <button
                  @click.prevent="editRecord()"
                  type="submit"
                  class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                >
                  Сохранить изменения
                </button>
              </div>
              <ErrorMessage
                v-if="errors.edit"
                :error="errors.edit"
                class="mt-2"
              />
            </div>
          </form>
        </div>
      </div>

      <!-- <p>Обложка курса:</p>
      <img
        v-if="data.image"
        :src="data.image"
        alt=""
        height="300"
        class="shadow"
      />
      <p v-else class="alert alert-info">Необходимо загрузить изображение:</p>
      <p style="font-weight: bold; font-size: 80%">
        картинка должна быть широкой!
      </p>
      <form @submit.prevent="submit">
        <div class="form-group">
          <div class="custom-file">
            <input
              type="file"
              class="custom-file-input"
              id="customFile"
              @change="onAttachmentChange"
            />
            <label class="custom-file-label" for="customFile"
              >Выберите файл для загрузки</label
            >
          </div>
        </div>
        <div class="form-group">
          <button type="submit" class="btn btn-primary">
            Сохранить обложку
          </button>
        </div>
        <div class="alert alert-danger" v-if="errors.uploadfile">
          {{ errors.uploadfile }}
        </div>
      </form>
      <hr />

      <form>
        <input type="hidden" name="id" v-model="data.id" />
        <p>
          Состояние Курса:
          <span
            v-bind:class="{
              'text-success': data.coursestate.id == 5,
              'text-muted': data.coursestate.id == 1,
            }"
            style="font-weight: bold"
            >{{ data.coursestate.name }}</span
          >
        </p>
        <div class="form-group">
          <label for="name" class="col-form-label">Название курса:</label>
          <input
            type="text"
            class="form-control"
            id="name"
            name="name"
            v-model="data.name"
          />
          <div
            class="alert alert-danger"
            v-if="errors.validationEdit && errors.validationEdit.name"
          >
            {{ errors.validationEdit.name[0] }}
          </div>
          <div class="form-group">
            <label for="department" class="col-form-label">Кафедра:</label>
            <select
              class="form-control"
              v-model="data.department_id"
              :required="true"
            >
              <option
                v-for="department in departments"
                v-bind:value="department.id"
                v-bind:key="department.id"
                :selected="department.id == data.department_id"
              >
                {{ department.name }}
              </option>
            </select>
          </div>
          <div class="form-group">
            <label for="category" class="col-form-label">Категория:</label>
            <select
              class="form-control"
              v-model="data.category_id"
              :required="true"
            >
              <option
                v-for="category in categories"
                v-bind:value="category.id"
                v-bind:key="category.id"
                :selected="category.id == data.category_id"
              >
                {{ category.name }}
              </option>
            </select>
          </div>

          <label for="name" class="col-form-label"
            >Примерная длительность (время на прохождение курса):</label
          >
          <input
            type="text"
            class="form-control"
            id="duration"
            name="duration"
            v-model="data.duration"
          />
          <div
            class="alert alert-danger"
            v-if="errors.validationEdit && errors.validationEdit.duration"
          >
            {{ errors.validationEdit.duration[0] }}
          </div>
        </div>
        <div class="form-group">
          <label class="col-form-label">Описание курса:</label>
          <textarea
            class="form-control"
            name="description"
            id="description"
            cols="30"
            rows="10"
            v-model="data.description"
          ></textarea>
          </div>
          </form>
      <button
        type="button"
        class="btn btn-primary"
        @click.prevent="editRecord()"
      >
        Сохранить изменения
      </button>
      <div class="alert alert-danger" v-if="errors.edit">
        {{ errors.edit }}
      </div> -->

      <!--
                    <Editor
                        api-key="API_KEY"
                        v-model="data.description"
                        :init="{
                            height: 800,
                            skin: 'oxide-dark',
                            plugins: 'wordcount', 
                            //menubar: 'insert',
                            image_advtab: true, 
                            //images_upload_url: '/upload1', 
                            automatic_uploads: true, 
                            file_picker_types: 'image', 
                            images_upload_handler: uploadImage
                        }"
                        plugins = 'image link insertdatetime table emoticons media'
                        toolbar = 'image link insertdatetime table emoticons media'
                    />
                    -->

      <!--
                <div class="form-group">
                    <label for="coursestate" class="col-form-label">Coursestate:</label>
                    <select v-model="data.coursestate_id" :required="true">
                        <option v-for="coursestate in coursestates" v-bind:value="coursestate.id" v-bind:key="coursestate.id" :selected="coursestate.id == data.coursestate_id" >{{coursestate.name}}</option>
                    </select>
                </div>
                -->
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Loader from "@/components/Loader";
// import Editor from '@tinymce/tinymce-vue'
import BreadCrumbs from "@/components/BreadCrumbs";
import PageTitle from "@/components/PageTitle";
import ErrorMessage from "../components/ErrorMessage.vue";
export default {
  //watch: {
  //  data: {
      //attachment: null,
      
          //  handler: function(val, oldVal) {
          //      //console.log(val, oldVal);
          //      // это щас не исп-ся, тут можно отслеживать изменение в data
          //      console.log('WATCH-325!');
          //  }
      
  //  },
  //},

  data() {
    return {
      attachment: null,
      loading: true,
      data: [],
      departments: [],
      categories: [],
      coursestate: "",
      //coursestates: [],
      errors: { load: "", edit: "", validationEdit: {}, uploadfile: "" },
      //selectedDepartment: '',  удалить !!
      bcrumbs: [],
      title: "Редактирование Курса",
    };
  },

  async mounted() {
    this.loadData();
  },

  methods: {
    async loadData() {
      this.errors.load = "";
      try {
        this.loading = true;
        let response = await axios.get(
          "admin/courses/" + this.$route.params.id + "/edit"
        );
        this.data = response.data.course;
        this.departments = response.data.departments;
        this.categories = response.data.categories;
        this.coursestate = response.data.coursestate;
        this.bcrumbs = response.data.bcrumbs;
        //this.coursestates = response.data.coursestates
        this.loading = false;
      } catch (e) {
        if (e.response.status == 401) {
          this.errors.load = "Нет доступа.";
        } else {
          this.errors.load = "Ошибка при загрузке данных";
        }
      }
    },

    onAttachmentChange(e) {
      this.attachment = e.target.files[0];
    },

    submit() {
      this.errors.uploadfile = "";
      const config = { "content-type": "multipart/form-data" };
      const formData = new FormData();
      formData.append("name", this.name);
      formData.append("attachment", this.attachment);

      axios
        .post(
          "admin/courses/" + this.data.id + "/courseUploadImage",
          formData,
          config
        )
        .then((response) => {
          this.data.image = response.data.image;
          //console.log(response);
        })
        .catch((error) => {
          if (error.response.status == 520) {
            this.errors.uploadfile = error.response.data.error;
          }
          if (error.response.status == 422) {
            this.errors.uploadfile = error.response.data.errors.attachment[0];
          } else {
            this.errors.uploadfile = "Неизвестная ошибка при загрузке файла.";
          }
        });
    },

    //
    // Edit record.
    //
    async editRecord() {
      this.errors.validationEdit = {};
      this.errors.edit = "";
      try {
        //let response = await axios.post('admin/courses/'+this.data.id, {id: this.data.id, name: this.data.name, description: this.data.description, department_id: this.data.department_id, _method: 'PUT'})
        let response = await axios.post(
          "admin/courses/" + this.data.id,
          Object.assign(this.data, { _method: "PUT" })
        );
        if (response.status == 200) {
          this.loadData();
        }
      } catch (e) {
        if (e.response.status == 422) {
          this.errors.validationEdit = e.response.data.errors;
        } else if (e.response.status == 520) {
          this.errors.edit = e.response.data.error;
        } else {
          this.errors.edit = "Неизвестная ошибка при редактировании записи.";
        }
      }
    },

    /*
        uploadImage(blobInfo, success, failure) {
            this.errors.uploadfile = ''
            const config = { 'content-type': 'multipart/form-data' }
            const formData = new FormData()
            formData.append('file', blobInfo.blob(), blobInfo.filename());

            //formData.append('name', this.name)
            //formData.append('attachment', this.attachment)

            //axios.post('chapters/testUpload', formData, config)
            axios.post('admin/courses/'+this.data.id+'/uploadimage', formData, config)
                //.then(response => console.log(response.data.message))
                //.catch(error => console.log(error))
                .then(response => {
                    console.log(response.data);
                    success(response.data.location);
                })
                .catch(error => {
                    failure('HTTP Error.'+error.response.data.errors.file[0]);
                    if (error.response.status == 520) {
                        this.errors.uploadfile = error.response.data.error
                    }
                    else {
                        this.errors.uploadfile = 'Неизвестная ошибка при загрузке файла.'
                    }
                })
        },
        */
  },

  components: {
    Loader,
    // Editor,
    BreadCrumbs,
    PageTitle,
    ErrorMessage,
  },
};
</script>